<template>
    <PopupRouterViewDetail label="Outgoing Check Status Detail" @hideMethod="onHidden" :isShowCopyData="false">

        <!-- APP_DETAIL_HEADER -->

        <b-card header="Outgoing Check Status" class="mb-3 card-max-width">
            <b-row>
				<b-col cols="12" lg="6">
						<app-input-textbox id="fieldset-code" label-cols-lg="12"  label="Code" label-for="input-code" size="sm" :model.sync="model.code" :isRequired="true" :state="validateState('code')" :errorMessage="getErrorMessage(errorMessage.code, 'code')"  @change="updateData" :isEditable="false" :isUpdatable="true"/>
						<app-input-textbox id="fieldset-name" label-cols-lg="12"  label="Name" label-for="input-name" size="sm" :model.sync="model.name"  @change="updateData" :isUpdatable ="true" :isEditable="false"/>
						<app-input-textbox id="fieldset-sequence" label-cols-lg="12"  label="Sequence" label-for="input-sequence" size="sm" type="number" :model.sync="model.sequence"  @change="updateData" :isUpdatable ="true" :isEditable="false"/>
						<app-input-textarea id="fieldset-remarks" label-cols-lg="12"  label="Remarks" label-for="input-remarks" size="sm" :model.sync="model.remarks"  @change="updateData" :isUpdatable ="true" :isEditable="false" />
					</b-col>
					<b-col cols="12" lg="6">
				</b-col>

            </b-row>
        </b-card>

        <!-- END_APP_DETAIL_HEADER -->

        <b-overlay :show="isBusy" no-wrap></b-overlay>
    </PopupRouterViewDetail>
</template>
<script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import OutgoingCheckStatus from '@/models/OutgoingCheckStatus/OutgoingCheckStatus';
import OutgoingCheckStatusList from '@/models/OutgoingCheckStatus/OutgoingCheckStatusList';
import OutgoingCheckStatusFilter from '@/filters/OutgoingCheckStatus/OutgoingCheckStatusFilter';

import PopupRouterViewDetail from '@/components/PopupRouterViewDetail';

import AppInputTextbox from '@/components/AppInputTextbox';
import AppInputTextarea from '@/components/AppInputTextarea';
import PopupRouterView from '@/components/PopupRouterView';
export default {
	components : {
		AppInputTextbox,
		AppInputTextarea,
		PopupRouterViewDetail,
		PopupRouterView,
	},
	mixins : [validationMixin],
	validations: {
		model: {
			code: {required},
		},
	},
	data() {
		return {
			errorMessage : {
				code: { required : "Code is Required."},
			},
			datas: Array(),
			selectAll:false,
			sortBy: '',
			sortDesc: '',
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			busy:false,
			isBusy: false,
			isDataLoading: false,
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			modelId: null,
			model: {},
			filterOutgoingCheckStatus : null,
			currentOutgoingCheckStatusPage : 1,
			outgoingCheckStatusPageSize: 10,
			sortByOutgoingCheckStatus: '',
			sortDescOutgoingCheckStatus: '',
			isShowPopupConfirmation : false,
			isDataCommited : false,
			mainRecordId : '',
		}
	},
	methods : {
		showPopupWithMessage : async function(message) {
			const msg = this.$createElement;
			let msgNode = '';
			let result = false;
			msgNode = msg('div', { domProps: { innerHTML: '<p>'+message+'</p>' } })
			await this.$bvModal.msgBoxConfirm([msgNode], {
				title: 'Alert',
				size: 'sm',
				buttonSize: 'sm',
				okVariant: 'success',
				cancelVariant: 'secondary',
				okTitle: 'Yes',
				cancelTitle: 'No',
				footerClass: 'p-2',
				hideHeaderClose: false,
				centered: true
			}).then(e=>{
				if(e){
					result = true;
				}
			});
			return result;
		},
		getOutgoingCheckStatus : async function(id) {
			this.isBusy = true;
			OutgoingCheckStatus.getData(this, id).then(result => {
				this.model = result;
				this.mainRecordId = String(result.mainRecordId);
				let promises = Array();


				Promise.all(promises).then((results) => {
					this.isBusy = false;
				});
			}).catch(error => { this.isBusy = false; });
		},
		downloadData() {
			this.isDownloadOutgoingCheckStatus = true;
			this.filterOutgoingCheckStatus.id = this.modelId;
			OutgoingCheckStatus.downloadDataDetail(this, this.filterOutgoingCheckStatus).then(result => {
				this.isDownloadOutgoingCheckStatus = false;
			}).catch(error => { this.isDownloadOutgoingCheckStatus = false; })
		},
		getOutgoingCheckStatuss : async function(input) {
			let filter = new OutgoingCheckStatusFilter();
			if (input != undefined) {
				filter.Name = input;
			}
			this.isOutgoingCheckStatusComboLoading = true;
			OutgoingCheckStatus.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.outgoingCheckStatuss = result.data
				}
				this.isOutgoingCheckStatusComboLoading = false;
			})
			.catch(error => {});
		},
		validateState(name) {
			if (!this.$v.model[name]) return null;
			const { $dirty, $error } = this.$v.model[name];
			return $dirty ? !$error : null;
		},
		getErrorMessage(message, name) {
			if (!this.$v.model[name]) return "";
			if (this.$v.model[name].required != undefined && !this.$v.model[name].required) {
				if (message.required) return message.required;
			}
		},
		handleScroll() {
			this.$refs.outgoingCheckStatusInput.scrollTop = 0;
		},
		saveAction(modalEvent) {
			modalEvent.preventDefault();
			this.handleScroll();
			let id = this.$route.params.id;
			this.$v.model.$touch(); 
			if (this.$v.model.$anyError) {
				return;
			} else {
				this.isBusy = true;
				let id = this.modelId;
				let model = this.model;

				let promises = Array();

				Promise.all(promises).then((results) => {
					if (id != '' && id != null && id != undefined) {
						OutgoingCheckStatus.updateData(this, model, id).then(result => {
							this.isDataCommited = true;
							if (result) {
								this.$router.push({ name: 'outgoingcheckstatusindex' });
							}
							this.isBusy = false;
						}).catch(error => { this.isBusy = false; });
					} else {
						OutgoingCheckStatus.insertData(this, model).then(result => {
							this.isDataCommited = true;
							if (result) {
								this.$router.push({ name: 'outgoingcheckstatusindex' });
							}
							this.isBusy = false;
						}).catch(error => { this.isBusy = false; });
					}
				});
			}
		},
		updateData() {
			let id = this.modelId;
			let model = this.model;
			let promises = Array();

			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					OutgoingCheckStatus.updateDataDetail(this, model, id)
					.catch((error) => {
						this.getOutgoingCheckStatus(id);
					});
				}
			});
		},
		onHidden() {
			this.getOutgoingCheckStatuss();
		},
		resetModal(modalType) {
			this.showPopupCopyData = false; 
			this.isShowPopupConfirmation = false;
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768 ) {
			}
		},
	},
	beforeMount() {
		this.filterOutgoingCheckStatus = new OutgoingCheckStatusFilter();
	},
	async mounted(){
		let id = this.$route.params.id;
		let copyData = this.$route.params.copydata;
		if (id != '' && id != null && id != undefined) {
			if (copyData != null && copyData != undefined) {
				this.getOutgoingCheckStatus(id);
			} else {
				this.modelId = id;
				this.getOutgoingCheckStatus(id);
			}
		}
		this.$nextTick(() => {
			window.addEventListener('resize', this.displayFilter);
			this.displayFilter();
		});
	},
	computed: {
		isAllowSaveDraft: {
			get: function() {
				if(this.model.mainRecordId != undefined || this.model.mainRecordId != null) return false;
				return true;
			}
		}
	},
	watch : {
	},
}
</script>
